import React, { useEffect, useRef, useState } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { endLive, generateAgoraToken, goLive } from '../axios/api';
import { options, rtc } from '../constant';
import AgoraRTC from "agora-rtc-sdk-ng";
import { Box, Button, Typography, Container, IconButton, Grid2 } from '@mui/material';
import MicIcon from '@mui/icons-material/Mic';
import MicOffIcon from '@mui/icons-material/MicOff';
import VideocamIcon from '@mui/icons-material/Videocam';
import VideocamOffIcon from '@mui/icons-material/VideocamOff';
import io from "socket.io-client";
import VisibilityIcon from '@mui/icons-material/Visibility';
import Lottie from "lottie-react";
import CallEndIcon from '@mui/icons-material/CallEnd';
import CloseIcon from '@mui/icons-material/Close';
import ProductSellerGrid from '../components/sellerProduct';
import goliveAnimation from "../components/lottie/live.json"
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import { EndlivePopUp } from '../components/streamEndPop';

const Golive = () => {
  const { id } = useParams();
  const location = useLocation();
  const [token, setToken] = useState('');
  const [liveData, setLiveData] = useState();
  const [isCameraOn, setIsCameraOn] = useState(true);
  const [isMicOn, setIsMicOn] = useState(true);
  const [comments, setComments] = useState([]);
  const [numUsers, setNumUsers] = useState(0);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true)
  const [likeCount, setLikeCount] = useState(0)
  const commentsEndRef = useRef(null);
  const [open, setOpen] = useState(false)
  const [defaults, setDefaults] = useState(false)
  const [showEndLiveButton, setShowEndLiveButton] = useState(false);


  const [socket, setSocket] = useState(null);

  useEffect(() => {
    if (liveData) {

      const socketConnection = io(process.env.REACT_APP_SOCKET_URL);
      setSocket(socketConnection)
      socketConnection.on("connect", () => {
        console.log("Connected to socket server");
        socketConnection.emit('join_stream', { streamId: id, userId: liveData.sellerId._id });
      });

      socketConnection.on("receive_comments", (comments) => {
        console.log("Received previous comments:", comments);
        setComments(comments);
      });

      socketConnection.on("user_count", (count) => {
        console.log("User count updated:", count);
        setNumUsers(count);
      });

      socketConnection.on("receive_comment", (newComment) => {
        console.log("Received new comment:", newComment);
        setComments((prevComments) => [...prevComments, newComment]);
      });

      return () => {
        console.log("Disconnecting from socket server...");
        socketConnection.disconnect();
      };
    }

  }, [id, liveData]);


  useEffect(() => {
    if (socket) {
      socket.emit("get_like_count", { streamId: id });

      socket.on("update_like_count", (likeCount) => {
        console.log("Updated like count:", likeCount);
        setLikeCount(likeCount);
      });

      return () => {
        socket.off("update_like_count");
      };
    }
  }, [socket, id]);



  const fetchData = async (id) => {
    try {
      const response = await goLive(id);
      if (response.data) {
        setLiveData(response.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleGolive = async () => {
    if (!liveData || !liveData._id) {
      console.error("Missing live data or token");
      return;
    }
    try {
      if (rtc.client) {
        if (rtc.client.state === "CONNECTED" || rtc.client.state === "CONNECTING") {
          await rtc.client.leave();
        }
      }

      const response = await generateAgoraToken({ channelName: liveData._id, uid: liveData.sellerId._id, role: "publisher" });
      if (response.data) {
        await rtc.client.join(options.appId, liveData._id, response.data.token, liveData.sellerId._id);
        rtc.localAudioTrack = await AgoraRTC.createMicrophoneAudioTrack();
        rtc.localVideoTrack = await AgoraRTC.createCameraVideoTrack();
        rtc.localVideoTrack.play("local-stream");
        await rtc.client.publish([rtc.localAudioTrack, rtc.localVideoTrack]);
        console.log("Publisher has started the stream!");
      }
    } catch (error) {
      console.error("Error while going live:", error);
    }
  };

  const toggleCamera = async () => {
    if (rtc.localVideoTrack) {
      await rtc.localVideoTrack.setEnabled(!isCameraOn);
      setIsCameraOn(!isCameraOn);
    }
  };

  const toggleMic = async () => {
    if (rtc.localAudioTrack) {
      const newMicStatus = !isMicOn;



      await rtc.localAudioTrack.setVolume(newMicStatus ? 100 : 0);
      // await rtc.localAudioTrack.setEnabled(newMicStatus);

      setIsMicOn(newMicStatus);

      console.log('Audio track muted status:', newMicStatus);
    }
  };

  const handleEndLive = async () => {
    try {
      const localContainer = document.getElementById("local-stream");
      if (localContainer) {
        localContainer.innerHTML = "";
      }

      if (rtc.localAudioTrack) {
        rtc.localAudioTrack.close();
      }
      if (rtc.localVideoTrack) {
        rtc.localVideoTrack.close();
      }

      rtc.client.remoteUsers.forEach((user) => {
        const playerContainer = document.getElementById(`remote-${user.uid}`);
        if (playerContainer) {
          playerContainer.remove();
        }
      });

      await rtc.client.leave();
      socket.emit('leave_stream', { streamId: id, userId: liveData.sellerId._id });
      console.log("Left the channel successfully");
      await endLive(id);
      socket.emit('end_stream', { streamId: id, userId: liveData.sellerId._id })
      // window.open(`${process.env.REACT_APP_FRONTENDLINK}/vendor/live-show`, '_blank');
      window.close()
    } catch (error) {
      console.error("Error leaving channel:", error);
    }
  };
  console.log(rtc.client,"clientsss");


  useEffect(() => {
    if (commentsEndRef.current) {
      commentsEndRef.current.scrollIntoView({ behavior: "smooth", block: "end" });
    }
  }, [comments]);


  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const tokenFromUrl = urlParams.get('token');
    if (tokenFromUrl) {
      localStorage.setItem("token", tokenFromUrl);
    }
    setToken(tokenFromUrl);
  }, [location.search]);

  useEffect(() => {
    if (id && token) {
      fetchData(id);
    }
  }, [id, token]);

  useEffect(() => {
    if (liveData) {
      rtc.client = AgoraRTC.createClient({ mode: "rtc", codec: "h264" });
      handleGolive();
    }
  }, [liveData]);

  useEffect(() => {
    if (loading && id && token && liveData) {
      setLoading(false)
    }
  }, [loading, id, token, liveData])






  // useEffect(() => {
  //   if(defaults) return
  //   const handleBeforeUnload = (event) => {
  //     event.preventDefault();
  //     event.returnValue = "Are you sure you want to leave? Your live session will end.";
  //   };

  //   const handleUnload = async (event) => {
  //     event.preventDefault();
  //     event.returnValue = "Are you sure you want to leave? Your live session will end.";
  //     try {
  //       if (socket) {
  //         socket.emit('leave_stream', { streamId: id, userId: liveData?.sellerId?._id });
  //         socket.emit('end_stream',{streamId: id, userId: liveData?.sellerId?._id})
  //       }
  //       handleEndLive()
  //       console.log("Live stream ended as user closed the tab.");
  //     } catch (error) {
  //       console.error("Error ending live stream on tab close:", error);
  //     }
  //   };

  //   window.addEventListener("beforeunload", handleBeforeUnload);
  //   window.addEventListener("unload", handleUnload);

  //   return () => {
  //     window.removeEventListener("beforeunload", handleBeforeUnload);
  //     window.removeEventListener("unload", handleUnload);
  //   };
  // }, [id, liveData, socket]);





  const styles = {
    loaderContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      backgroundColor: 'black',
      color: 'white',
      textAlign: 'center',
    },
    message: {
      marginTop: '20px',
      fontSize: '20px',
      fontWeight: 'bold',
    }
  };



  if (loading) {
    return (
      <div style={styles.loaderContainer}>
        <Lottie
          animationData={goliveAnimation}
          loop={true}  // Set loop to true to keep playing
          autoplay={true}  // Ensures the animation starts automatically
          style={{ height: "200px" }}
        />
        <p style={styles.message}>Starting Live Stream...</p>
      </div>
    );
  }





  return (
    <div className="container-fluid pt-sm-2 ps-sm-2 p-0 " style={{ width: "100%", background: "#fff", display: "flex", justifyContent: "center", alignItems: "center" }}>
      <Grid2 container spacing={1} style={{ width: "100%" }}>
        {/* <Grid2 size={{ xs: false, sm: 4, md: 4 }}
          style={{
            backgroundColor: 'transparent',
            height: '100%',
            overflowY: 'auto',
            overflowX: 'hidden',
          }}
          sx={{
            '&::-webkit-scrollbar': {
              display: 'none',
            },
            scrollbarWidth: 'none',
          }}>
          
        </Grid2> */}
        <Grid2 className="live-admin-side" size={{ xs: 12, sm: 6, md: 9 }} style={{
          position: "relative",
          height: '100%',
        }}>
          {/* <Container
            maxWidth="xs"
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              height: '100vh',
              textAlign: 'center',
              paddingTop: '20px',
              backgroundColor: '#000',
            }}
          > */}
          <div
            id="local-stream"
            style={{
              width: '100%',
              maxWidth: "100%",
              height: '100%',
              aspectRatio: '16/7',
              backgroundColor: '#000',
              borderRadius: '8px',
              position: 'relative',
              overflow: 'hidden',
            }}
            onMouseEnter={() => setShowEndLiveButton(true)}
            onMouseLeave={() => setShowEndLiveButton(false)}
          >
            <div className="live-pro-box">
              <div style={{
                position: "absolute",
                top: 10,
                left: 10,
                color: 'white',
                // backgroundColor: 'rgba(0, 0, 0, 0.5)',
                zIndex: "999",
                borderRadius: "50px",
                '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.7)' }
              }}>
                <img src={liveData?.sellerId?.image} alt='profile' height={45} width={45} style={{ borderRadius: "50px", objectFit: "cover" }} />
                <span className="col-md-8 col-6 video-title text-truncate ps-2">{liveData ? `Streaming: ${liveData.title}` : "Waiting to start stream..."}</span>
              </div>

              <div className="live-view"
                style={{
                  position: "absolute",
                  color: 'white',
                  zIndex: "999",
                  background: "#ffe1e7",
                  borderRadius: "50px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.7)' },
                }}
              >
                <VisibilityIcon sx={{ color: "#e1306c"  }} />
                {numUsers && <span style={{ marginLeft: "5px",  color: "#333" }}>{numUsers - 1}</span>}
              </div>
            </div>
            <div
              style={{
                position: "absolute",
                bottom: 10,
                right: 10,
                color: 'white',
                zIndex: "999",
                borderRadius: "50px",
                background: "#29a6ff",
                padding: "3px 12px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.7)' },
              }}
            >
              <ThumbUpIcon sx={{ fontSize: "24px" }} />
              <span style={{ marginLeft: "5px", fontSize: "16px", color: "#fff" }}>{likeCount}</span>
            </div>

            {/* <IconButton
                onClick={toggleMic}
                sx={{
                  position: 'absolute',
                  top: 10,
                  right: 10,
                  color: 'white',
                  backgroundColor: 'rgba(0, 0, 0, 0.5)',
                  zIndex: "999",
                  '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.7)' }
                }}
              >
                {isMicOn ? <MicIcon /> : <MicOffIcon />}
              </IconButton>

              <IconButton
                onClick={toggleCamera}
                sx={{
                  position: 'absolute',
                  top: 50,
                  right: 10,
                  color: 'white',
                  backgroundColor: 'rgba(0, 0, 0, 0.5)',
                  zIndex: "999",
                  '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.7)' }
                }}
              >
                {isCameraOn ? <VideocamIcon /> : <VideocamOffIcon />}
              </IconButton> */}
            <div className="cross-btn-box" style={{
                position: "absolute",
                top: 5,
                right: 7,
                color: 'white',
                zIndex: "9999",
                cursor: "pointer",
                '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.7)' },
              }}><Button onClick={() => { setDefaults(true); setOpen(true) }} className="cross-btn"><CloseIcon /></Button>
            </div>

            {showEndLiveButton && (
              <Button
                onClick={() => { setDefaults(true); setOpen(true) }}
                className="end-leave"
                variant="contained"
                color="error"
                sx={{
                  position: 'absolute',
                  bottom: 10,
                  left: '50%',
                  transform: 'translateX(-50%)',
                  zIndex: 999,
                  backgroundColor: 'rgba(255, 0, 0, 0.7)',
                  '&:hover': { backgroundColor: 'rgba(255, 0, 0, 0.9)' }
                }}
              >
                <CallEndIcon />
              </Button>
            )}
          </div>
          {/* </Grid2> */}

          {/* <Typography variant="h6" sx={{ marginTop: 2, color: 'white' }}>
              {liveData ? `Streaming: ${liveData.title}` : "Waiting to start stream..."}
            </Typography> */}

          {/* </Container> */}
          <div>
            <ProductSellerGrid products={liveData?.products} />
          </div>
        </Grid2>
        <Grid2
          size={{ xs: 12, sm: 6, md: 3 }}
          className="chat-board"
          style={{
            height: '97vh',
            padding: '20px',
            // overflowY: "auto",
            overflow: 'hidden',
            backgroundColor: '#f4f4f4',
            display: 'flex',
            position: "sticky",
            top: "0px",
            flexDirection: 'column',
            justifyContent: 'flex-end',
            borderRadius: "10px",
            border: "1px solid #dbdbdb"
          }}
          sx={{
            '&::-webkit-scrollbar': {
              display: 'none',
            },
            scrollbarWidth: 'none',
          }}
        >
          <h5 style={{borderBottom: "1px solid #b9b9b9"}} className="d-sm-block d-none pb-3">Live Support Here</h5>
          <div
            id="comments"
            style={{
              maxHeight: '80%',
              overflowY: 'scroll',
              width: '100%',
              marginBottom: '20px',
              flex: 1,
              paddingRight: '10px',
            }}
          >
            {comments.map((commentData, index) => (
              <div
                key={index}
                className="chat-box-msg"
                style={{
                  padding: '3px 7px',
                  marginBottom: '10px',
                  backgroundColor: '#ffffff',
                  borderRadius: '8px 8px 0 8px',
                  // border: '1px solid #ddd',
                  // boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
                  maxWidth: '100%',
                  marginLeft: 'auto',
                  marginRight: '10px',
                }}
              >
                <div className="profile-box">
                  <img src={commentData.userId?.image} height={25} width={25} alt="Image" />
                  <p className="name"><b>{commentData.userId?.name}</b> :- {commentData.comment}</p>

                </div>
                {/* <p className="mt-2  live-cmt">{commentData.comment}</p> */}
              </div>
            ))}
            <div ref={commentsEndRef} />
          </div>
        </Grid2>

      </Grid2>
      <EndlivePopUp open={open} handleClose={handleEndLive} onClose={() => { setDefaults(false); setOpen(false) }} />
    </div>
  );
};

export default Golive;
